import { Context, Environment, Language } from './Context';
import staging from '@app/lib/store-context/staging';
import production from '@app/lib/store-context/production';

export const SUPPORTED_LANGUAGES = [
    'en-AU',
    'en-SG',
    'en-US',
    'en-UK',
    'en-EU',
    'en-ROW',
    'en-KOR',
    'en-TW',
    'en-HK'
] as const;

const environment: Environment =
    process.env.NEXT_PUBLIC_STAGING_ENV === 'true' ? staging : production;

/**
 * Gets the correct store context from brand config for a given routePrefix from
 * const { lang } = params;
 *
 * export default async function Page({ params }) {
 *   const context = getContext(params.lang);
 *   const clientSettings: ShopifyClientContext = {
 *       shopifyDomain: context.shopifyStorefrontUrl,
 *   }
 * }
 */

export function getContext(language: Language | null): Context {
    const { contexts } = environment;
    const defaultContext: Context = contexts[0];
    const countryContext = contexts.find(
        (context) => context.language === language
    );
    return countryContext || defaultContext;
}
